import React from 'react';
import { motion } from 'framer-motion';
import { Map, Zap, CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy text-cream overflow-hidden relative" data-id="element-156">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-purple/5 skew-x-12 transform origin-top-right" data-id="element-157"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-158">
        {/* Hero section with mockup */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-159">
          {/* Text content */}
          <div className="text-center lg:text-left" data-id="element-160">
            <motion.span initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-coral font-medium tracking-wider uppercase text-sm mb-2 block" data-id="element-161">
              La Solución
            </motion.span>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-4xl sm:text-5xl font-bold mb-4 font-serif" data-id="element-162">
              Kit "Dormí de Nuevo (40+)"
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-xl text-gray-300 max-w-xl" data-id="element-163">
              No es "leer y ya". Es tener un plan armado para el momento más
              vulnerable del día.
            </motion.p>
          </div>

          {/* Product mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 30
        }} whileInView={{
          opacity: 1,
          scale: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative flex justify-center lg:justify-end" data-id="element-164">
            <div className="relative" data-id="element-165">
              {/* Glow effect behind image */}
              <div className="absolute inset-0 bg-coral/20 blur-3xl rounded-full scale-75" data-id="element-166"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3cRyGazRgYY5dKy7KJGXop/heylloyd-image-1770281790986.png" alt="Kit Dormí de Nuevo (40+) - Protocolo Anti-Despertares 3AM" className="relative z-10 w-full max-w-md rounded-2xl shadow-2xl" data-id="element-167" />
            </div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-168">
          <SolutionCard icon={Map} title="Mapa 3AM" description="Identificás tu escenario dominante: calor/sofocos, ansiedad, glucosa/hambre, entorno o hábitos." delay={0.3} data-id="element-169" />
          <SolutionCard icon={Zap} title="Reset de 12 Minutos" description="Un protocolo específico para bajar la activación y volver a dormir sin entrar en espiral mental." delay={0.4} highlighted data-id="element-170" />
          <SolutionCard icon={CheckCircle2} title="Plan 14 Noches" description="Checklist de dormitorio y un plan progresivo para ajustar tu sueño sin caos ni disciplina militar." delay={0.5} data-id="element-171" />
        </div>
      </div>
    </section>;
}
function SolutionCard({
  icon: Icon,
  title,
  description,
  delay,
  highlighted = false
}: {
  icon: any;
  title: string;
  description: string;
  delay: number;
  highlighted?: boolean;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className={`relative p-8 rounded-2xl ${highlighted ? 'bg-purple/20 border border-purple/30 shadow-2xl shadow-purple/10' : 'bg-white/5 border border-white/10'}`} data-id="element-172">
      <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 ${highlighted ? 'bg-coral text-navy' : 'bg-white/10 text-coral'}`} data-id="element-173">
        <Icon className="w-7 h-7" data-id="element-174" />
      </div>
      <h3 className="text-2xl font-bold mb-4 font-serif" data-id="element-175">{title}</h3>
      <p className="text-gray-300 leading-relaxed" data-id="element-176">{description}</p>
    </motion.div>;
}